import React from 'react';
import axios from './../../constants/axios';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router';

class SalesDue extends React.Component {

   constructor(props, context) {
      super(props, context);
      this.state = {
         salesDue: []
      };
   }

   componentDidMount() {
      axios.get('contacts/salesDue')
         .then((res) => {
            this.setState({
               salesDue: res.data
            });
         });
   }

   render() {
      const {salesDue} = this.state;
      return (
         <Table striped bordered condensed hover >
            <thead>
            <tr>
               <th>Name</th>
               <th>Mobile</th>
               <th>Due Amount</th>
               <th>First Due</th>
               <th>Last Due</th>
               <th>##</th>
            </tr>
            </thead>
            <tbody>
            {salesDue.map((d) => (
               <tr key={d.id} >
                  <td>{d.name}</td>
                  <td>{d.mobile}</td>
                  <td>{d.due}</td>
                  <td>{d.firstInvoiceDate}</td>
                  <td>{d.lastInvoiceDate}</td>
                  <td>
                     <Link to={`/contact/detail/${d.contact_id}/invoice`} >Detail</Link>
                  </td>
               </tr>
            ))}
            </tbody>
         </Table>
      );
   }
}

SalesDue.contextTypes = {
   router: React.PropTypes.object.isRequired
};


export default SalesDue;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/SalesDue.js
 **/